module.exports = __webpack_public_path__ + "static/media/card1.212b64bc.png";